import { render, staticRenderFns } from "./GridRecepcion.vue?vue&type=template&id=5e2d2c94&"
import script from "./GridRecepcion.vue?vue&type=script&lang=js&"
export * from "./GridRecepcion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports